/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Catalog_FailedInputs */

const en_us2_onboarding_catalog_failed = /** @type {(inputs: Onboarding_Catalog_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The equipment list could not be loaded.`)
};

const pt_br2_onboarding_catalog_failed = /** @type {(inputs: Onboarding_Catalog_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não deu para carregar a lista de equipamentos.`)
};

const es_419_onboarding_catalog_failed = /** @type {(inputs: Onboarding_Catalog_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo cargar la lista de equipo.`)
};

const pt_pt2_onboarding_catalog_failed = /** @type {(inputs: Onboarding_Catalog_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não foi possível carregar a lista de equipamento.`)
};

const fr_fr2_onboarding_catalog_failed = /** @type {(inputs: Onboarding_Catalog_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossible de charger la liste des équipements.`)
};

const de_de2_onboarding_catalog_failed = /** @type {(inputs: Onboarding_Catalog_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Geräteliste konnte nicht geladen werden.`)
};

const it_it2_onboarding_catalog_failed = /** @type {(inputs: Onboarding_Catalog_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossibile caricare l'elenco dell'attrezzatura.`)
};

/**
* | output |
* | --- |
* | "The equipment list could not be loaded." |
*
* @param {Onboarding_Catalog_FailedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const onboarding_catalog_failed = /** @type {((inputs?: Onboarding_Catalog_FailedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Catalog_FailedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_onboarding_catalog_failed(inputs)
	if (locale === "es-419") return es_419_onboarding_catalog_failed(inputs)
	if (locale === "pt-PT") return pt_pt2_onboarding_catalog_failed(inputs)
	if (locale === "fr-FR") return fr_fr2_onboarding_catalog_failed(inputs)
	if (locale === "de-DE") return de_de2_onboarding_catalog_failed(inputs)
	if (locale === "it-IT") return it_it2_onboarding_catalog_failed(inputs)
	return en_us2_onboarding_catalog_failed(inputs)
});
export { onboarding_catalog_failed as "onboarding.catalog_failed" }